import React from "react";

import { OnlineLink } from "components";
import { getFullName } from "helpers";

import styles from "../search.module.scss";

export const pendResultItem = (obj): { [key: string]: any } => {
	return (
		<div
			className={`${styles.wrappSearchInfo} flex-wrap`}
			style={{ justifyContent: "flex-start" }}
		>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Pend Number:</p>
					{obj?.applicationId && obj?.id && (
						<p className="mb-0">
							<OnlineLink
								to={`/applications/${obj?.applicationId}/pend/${obj?.id}`}
								target="_blank"
								style={{ marginLeft: "15px" }}
							>
								{obj?.number}
							</OnlineLink>
						</p>
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>App ID:</p>
					<p className="mb-0">
						<OnlineLink
							to={`/applications/${obj?.applicationId}/get-started`}
							target="_blank"
							style={{ marginLeft: "15px" }}
						>
							{obj?.application?.number}
						</OnlineLink>
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>DBA:</p>
					<p className={`break-word ${styles.content}`}>
						{obj?.application?.dba_name}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Status:</p>
					<p className={styles.content}>{obj?.status?.displayName}</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Reason:</p>
					<div className={styles.content}>
						{obj?.reasons?.map((reason, i) => (
							<p key={`reason-${i}`} className="mb-0">
								{reason?.name}
							</p>
						))}
					</div>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Pended to:</p>
					<p className={styles.content}>
						{getFullName(obj?.pendedTo)}
					</p>
				</div>
			}
		</div>
	);
};
